import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import get from 'lodash/get';

import { Api, RegisterRequestV2, useApi } from '@sbv-clients/data-access-api';
import { useSnackBar } from '@sbv-clients/ui-shared';

const register = (api: Api) => (registerParams: RegisterRequestV2) => {
  return api.accountApi.accountV2RegisterPost({
    registerRequestV2: { ...registerParams },
  });
};

export const useRegister = () => {
  const navigate = useNavigate();
  const api = useApi();
  const { notifyError } = useSnackBar();

  return useMutation(register(api), {
    onSuccess: () => {
      navigate('/auth/success?action=register');
    },
    onError: async (error) => {
      const message =
        get(error, 'response.data.message', '') || get(error, 'message', '');
      notifyError(message);
    },
  });
};
